export enum WhiteLabelSources {
  PG_MOBILE = 'pg_mobile',
  DEVICE_SUPPORT = 'device_support',
  HARVEY_NORMAN = 'harvey_norman_techteam_plus',
  TECH_EXPERT = 'tech_expert',
  ASSURANT_TECH_PRO = 'assurant_tech_pro',
  DIRECTV = 'directv',
  TMO_PGH = 'protection_360_home_tech',
  XTDP = 'xfinity_total_device_protection',
  VODAFONE_PORTUGAL = 'vodafone_portugal',
}
